import { isDev } from "@/lib/chillnn/enviroment";

const supportSiteBase = isDev ? "https://dev-support.chillnn.com" : "https://support.chillnn.com";

export const externalLink = {
	chillnnNotion: "https://www.notion.so/chillnn/3ce962f07d7d42e890925ecef73489e7",
	faqSite: supportSiteBase,
	faqSiteUrl: (hotelID: string) => `${supportSiteBase}?hotel_id=${hotelID}`,
	/** Support 改善要望フォーム。施設文脈は `hotel_id` クエリで渡す */
	feedbackSiteUrl: (hotelID: string) => {
		const url = new URL("/feedback", supportSiteBase);
		url.searchParams.set("hotel_id", hotelID);
		return url.toString();
	},
};
